import { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Play } from "lucide-react";
import { Eyebrow } from "./Brand";
import { Reveal } from "./Motion";

export const VideoSection = () => {
  const ref = useRef(null);
  const sec = useRef(null);
  const [playing, setPlaying] = useState(false);
  const { scrollYProgress } = useScroll({ target: sec, offset: ["start end", "end start"] });
  const rot = useTransform(scrollYProgress, [0, 1], [-5, 4]);
  const play = () => { ref.current?.play()?.catch(() => setPlaying(false)); setPlaying(true); };

  return (
    <section id="film" ref={sec} className="relative bg-[#0B1938] text-white py-20 sm:py-32 overflow-hidden grain" data-testid="recruitment-video-section">
      <div className="absolute right-[-10%] top-1/2 -translate-y-1/2 h-[640px] w-[640px] rounded-full bg-[#2F7FF0]/20 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-10 grid lg:grid-cols-12 gap-14 lg:gap-10 items-center">
        <Reveal className="lg:col-span-6">
          <Eyebrow light>Driver recruitment film · 30 sec</Eyebrow>
          <h2 className="font-display text-4xl sm:text-6xl font-extrabold tracking-tight mt-4 leading-[0.95]">Your next delivery gig is already parked outside.</h2>
          <p className="mt-6 text-slate-300 text-base sm:text-lg leading-relaxed max-w-lg">Small finds, car-sized gigs, big hauls.</p>
          <div className="mt-9 flex flex-wrap items-center gap-5">
            <a href="#signup" data-testid="video-claim-driver-spot-btn" className="inline-flex rounded-full bg-[#2F7FF0] text-white font-bold px-7 py-4 hover:bg-white hover:text-[#13296B] transition-colors duration-300">Claim your driver spot</a>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">Marketgetr Driver Ad · v2</span>
          </div>
        </Reveal>
        <div className="lg:col-span-6 flex justify-center">
          <Reveal>
            <motion.div style={{ rotate: rot }} className="relative w-[78vw] max-w-[340px] sm:max-w-[360px] aspect-[9/16] rounded-[36px] p-2.5 bg-white/10 ring-1 ring-white/20 shadow-[0_50px_100px_-30px_rgba(47,127,240,0.6)]">
              <div className="relative h-full w-full rounded-[28px] overflow-hidden bg-black">
                <video
                  ref={ref}
                  poster="/video/poster-v2.jpg"
                  preload="metadata"
                  playsInline
                  controls={playing}
                  onPlay={() => setPlaying(true)}
                  className="h-full w-full object-cover"
                  data-testid="recruitment-video-player"
                >
                  <source src="/video/driver-ad-v2.mp4" type="video/mp4" />
                  <source src="/video/driver-ad-v2.webm" type="video/webm" />
                </video>
                {!playing && (
                  <button onClick={play} data-testid="recruitment-video-play-btn" aria-label="Play driver recruitment video" className="group absolute inset-0 flex items-end justify-center pb-10 bg-gradient-to-t from-[#0B1938]/70 via-transparent to-transparent">
                    <motion.span whileHover={{ scale: 1.06 }} whileTap={{ scale: 0.95 }} className="flex items-center gap-3 rounded-full bg-white text-[#13296B] pl-2.5 pr-6 py-2.5 shadow-2xl">
                      <span className="h-12 w-12 rounded-full bg-[#2F7FF0] flex items-center justify-center"><Play className="h-5 w-5 text-white fill-white ml-0.5" /></span>
                      <span className="font-display font-bold text-lg">Watch the film</span>
                    </motion.span>
                  </button>
                )}
              </div>
            </motion.div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
